// core
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';

// servies
import {UtilsService} from './utils/utils.service';

// constants
import {TranslateService} from '@ngx-translate/core';
import {PreviousPageService} from './shared/services/previous-page.service';
import {UpdateProfileService} from './update-my-profile/services/update-my-profile.service';
import {filter, tap} from 'rxjs/operators';

declare var $;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(
    private _utilsService: UtilsService,
    private _router: Router,
    private _translateService: TranslateService,
    private _previousPageService: PreviousPageService,
    private _updateProfileService: UpdateProfileService,
    private _cookieService: CookieService,
  ) {

    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      tap((navEnd: NavigationEnd) => {
        this._previousPageService.setPreviousPage(navEnd.urlAfterRedirects);
      })
    );

  }

  ngOnInit() {
    this._utilsService.setDefaultLanguage(this._cookieService.get("umngUserLang"));
  }

}
